module.exports = __webpack_public_path__ + "img/user-acquasition-bg-mobile.b1220a38.png";